import * as React from "react";
const SvgFiRrPersonDressSimple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m6.749 16.485a3 3 0 0 1-1.25.826v3.188a1 1 0 1 1-2 0v-3h-2v3a1 1 0 1 1-2 0v-3.188a3 3 0 0 1-1.248-.826 3 3 0 0 1-.728-2.357l.876-7.008a4.14 4.14 0 0 1 4.1-3.62 4.14 4.14 0 0 1 4.102 3.621l.876 7.007a3 3 0 0 1-.728 2.357m-7.241-2.109a.99.99 0 0 0 .242.786A.99.99 0 0 0 10 18h4c.29 0 .558-.12.75-.338a.99.99 0 0 0 .242-.786l-.876-7.008A2.136 2.136 0 0 0 12 8a2.136 2.136 0 0 0-2.116 1.868z"
    />
  </svg>
);
export default SvgFiRrPersonDressSimple;
